import React from "react";
import { Modal, Row, Col, Button } from "react-bootstrap";
import { EnvironmentHelper } from "../helpers";

interface Props {
  playlistId?: number,
  screenId?: number,
  messageId?: number,
  onClose: () => void,
  shape?: string
}

export const PreviewModal: React.FC<Props> = props => {

  const [iframeContent, setIframeContent] = React.useState<React.ReactElement>(null);

  function getIframeContent() {
    let result = <></>
    //var holder = document.getElementById('previewHolder');
    const holder = document.querySelector("#iframeHolder");
    if (holder) {
      var screenWidth = 1920.0;
      var screenHeight = 1080.0;
      if (props.shape === "9:16") {
        screenWidth = 1080.0;
        screenHeight = 1920.0;
      }
      var percent = holder.clientWidth / screenWidth;
      var hPercent = holder.clientHeight / screenHeight;
      if (hPercent < percent) percent = hPercent;


      var leftOffset = screenWidth * (1.0 - percent) / 2.0;
      var topOffset = screenHeight * (1.0 - percent) / 2.0;

      if (!EnvironmentHelper.PlayerRoot) {
        return <div style={{ padding: "20px", textAlign: "center" }}>Preview not available in development mode without REACT_APP_PLAYER_ROOT environment variable</div>;
      }

      let url = EnvironmentHelper.PlayerRoot + "/display/?preview=1&screenId=" + props.screenId;
      if (props.playlistId) url = EnvironmentHelper.PlayerRoot + "/display/?preview=1&auto=1&playlistIds=" + props.playlistId
      else if (props.messageId) url = EnvironmentHelper.PlayerRoot + "/message/?id=" + props.messageId + "&preview=1";

      var previewUrl = url;
      let style: any = {
        width: screenWidth,
        marginLeft: -leftOffset,
        marginRight: -leftOffset,
        height: screenHeight,
        marginTop: -topOffset,
        marginBottom: -topOffset,
        border: 0,
        transform: "scale(" + percent.toString() + ")"
      }
      result = <iframe id="previewFrame" src={previewUrl} style={style} scrolling="no" title="Message Preview"></iframe>;
    }
    return result;
  }

  React.useEffect(() => {
    setTimeout(() => {
      setIframeContent(getIframeContent());
    }, 200);

  }, []); // eslint-disable-line

  const getTitle = () => {
    if (props.playlistId) return "Preview Playlist";
    else return "Preview Screen";
  }

  const handleRemoteClick = (key: string) => {
    const previewFrame: any = document.getElementById('previewFrame');
    const cmd = { action: "key", value: key };
    if (previewFrame && previewFrame.contentWindow && EnvironmentHelper.PlayerRoot) {
      previewFrame.contentWindow.postMessage(JSON.stringify(cmd), EnvironmentHelper.PlayerRoot);
    }
  }

  return (
    <Modal id="previewModal" show={true} dialogClassName="custom-modal" bsClass="my-modal" onHide={props.onClose}>
      <Modal.Header closeButton>
        <Modal.Title>{getTitle()}</Modal.Title>
      </Modal.Header>
      <Modal.Body style={{ display: "flex" }}>
        <Row style={{ flex: 1 }}>
          <Col id="iframeHolder" md={9} sm={12} style={{minHeight:200}}>
            {iframeContent}
          </Col>
          <Col id="remoteControl" md={3} sm={12}>
            <h2>Remote</h2>
            <Button variant="info" onClick={() => handleRemoteClick("ArrowUp")} style={{ width: 75, marginRight: 10 }}>Up</Button>
            <table style={{ marginTop: 5, marginBottom: 5, marginLeft: "auto", marginRight: "auto" }}>
              <tr>
                <td><Button variant="info" onClick={() => handleRemoteClick("ArrowRight")}>Left</Button></td>
                <td style={{ paddingLeft: 5, paddingRight: 5 }}><Button variant="info" onClick={() => handleRemoteClick("Enter")} style={{ width: 75 }} >Center</Button></td>
                <td><Button variant="info" onClick={() => handleRemoteClick("ArrowRight")}>Right</Button></td>
              </tr>
            </table>
            <Button variant="info" onClick={() => handleRemoteClick("ArrowDown")} style={{ width: 75, marginRight: 10 }}>Down</Button>

            <p style={{ marginLeft: 20, marginTop: 150, color: "#999", textAlign: "left" }}>Note: Some browsers may className="d-grid" videos from auto-playing.</p>
            <p style={{ marginLeft: 20, color: "#999", textAlign: "left" }}>If you receive an error, click on the black preview window and use the right button on the remote to move to the next message and videos should play.</p>
          </Col>
        </Row>
      </Modal.Body>
    </Modal>
  );
};